// import BannerD from "../../Image/Banner/banner-Kv-d.jpg";
// import BannerM from "../../Image/Banner/banner-Kv-m.jpg";
// import { FaCar, FaFileDownload, FaCogs } from "react-icons/fa";
// import { FaQuoteRight } from "react-icons/fa6"; 
const bannerData = [

    {
    cover: "https://www.kia.com/content/dam/kia2/in/en/images/our-vehicles/sonetro/teaser/desktop.mp4",
    mobileCover: "https://www.kia.com/content/dam/kia2/in/en/images/our-vehicles/sonetro/showroom/1080X1980-m.mp4",
    type: "imgbanner",
    title: "The Kia Sorento",
    subtitle: "Global Icon. India Bound.",
    link: "/sorento"
  },
  {
    cover: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/Background%2Fbncap_d_2.avif?alt=media&token=1878cc8b-e64d-4285-85eb-1e45835f751b",
    mobileCover: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/Background%2Fbncap_m.webp?alt=media&token=38d419e7-7f86-4c5e-a873-62b699f9d509",
    type: "imgbanner",
    title: "",
    subtitle: "",
    link: ""
  },



  {
    cover: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/Background%2Fbanner_d.avif?alt=media&token=59bbc414-47ec-4208-92cb-62c7527dfba0",
    mobileCover: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/Background%2FSyros-mobile.webp?alt=media&token=92291dd2-5d68-493d-a64b-24b2231bc2be",
    type: "imgbanner",
    title: "Presenting The 2026 Kia Syros.",
    subtitle: "Made for your world. And everyone in it.",
    link: ""
  },

  {
    cover:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/Background%2Fseltos_d_1.avif?alt=media&token=9416699a-1899-41e1-a464-395d6fe94c73",
    mobileCover: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/Background%2Fseltos_m_1.webp?alt=media&token=310ad304-97f3-4175-b51c-6efd9b156e3f",
    title: "The all-new Seltos ",
    subtitle: "Starting at ₹10 99 000 - the original gamechanger is here.",
    type: "banner",
    link: "/newseltos"
  },
  {
    cover:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/Background%2F6_sec_d.mp4?alt=media&token=b273bee5-1a3f-4bac-932c-8666c3a3cd04",
    title: "The Carens Clavis EV",
    subtitle: "it's an E.We",
    type: "banner",
    link: "/carens-clavis-ev"
  },
  {
    cover:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/Background%2Fclavis_d.avif?alt=media&token=7ea0de2d-6077-42ba-8d9d-b6bdd7ce61b9",
       mobileCover: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/Background%2Fclavis_m.webp?alt=media&token=1a9b3e80-d815-46a5-baf1-ad350cf03542",
    title: "The Carens Clavis",
    subtitle: "For epic journeys",
    type: "banner",
    link: "/carens-clavis"
  },

  {
    cover:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/Background%2Fbanner_d.avif?alt=media&token=59bbc414-47ec-4208-92cb-62c7527dfba0",
    mobileCover: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/Background%2FSyros-mobile.webp?alt=media&token=92291dd2-5d68-493d-a64b-24b2231bc2be",
    title: "The Syros",
    subtitle: "Evolved by the future.",
    type: "banner",
    link: "/syros"
  },

  {
    cover:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/Background%2FEV9_Desktop.mp4?alt=media&token=0180a103-7cf9-4b82-a814-da8109373887",
    title: "The Kia EV9",
    subtitle: "The World's Most Inspiring Electric. Ever.",
    type: "banner",
    link: "/ev9"
  },
  {
    cover:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/Background%2FCanival_Web.mp4?alt=media&token=add442c8-5e64-4972-8b24-e653cc56cb1c",
    title: "The new Kia Carnival Limousine",
    subtitle: "Your own luxury liner ",
    type: "banner",
    link: "/carnival"
  },
  {
    cover:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/Background%2FOption-07-1.mp4?alt=media&token=ed319bc3-d4ce-4688-920b-b0daff9bad27",
    title: "Kia EV6",
    subtitle: "The Electric Superstar",
    type: "banner",
    link: "/ev6"
  },
  {
    cover:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/Background%2FCarens_Digital_d.avif?alt=media&token=5b0977f2-1a29-403c-878f-f21f5b611a6d",
    mobileCover: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/Background%2FCarens_Digital_m.webp?alt=media&token=8f72d9f0-8228-49de-a644-fdff97f0a492",
    title: "Kia Carens",
    subtitle: "From a different world.",
    type: "",
    link: "/carens"
  },
  {
    cover:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/Background%2Fdesktop-new.mp4?alt=media&token=e0dc5004-7e29-4413-9134-ca51953c8dd6",
    title: "New Sonet",
    subtitle: "The Wild. Reborn.",
    type: "banner",
    link: "/sonet"
  },
];



const imagesHome = [
  {
    cover:
      "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Home%2Fkia%20Syros%20carousel.jpg?alt=media&token=6cd44be6-243e-43b0-bde1-01b19dc6fb12",
    link: "/syros",
  },
  {
    cover:
      "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Home%2Fkia%20Seltos%20carousel.jpg?alt=media&token=f1d79db0-23cf-4632-a59f-a14138ee8565",
    link: "/seltos",
  },
  {
    cover:
      "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Home%2Fkia%20Sonet%20carousel.jpg?alt=media&token=2da14d7f-c389-40c5-86e7-e7eabf942e4b",
    link: "/sonet",
  },
  {
    cover:
      "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Home%2Fkia%20Carens%20carousel.jpg?alt=media&token=26f76e06-bcd4-4fda-adb0-a4563f68fdd8",
    link: "/carens",
  },
  {
    cover:
      "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Home%2Fkiacarouselev6.jpg?alt=media&token=06327df5-5594-445c-86cd-70aeb60f66e7",
    link: "/ev6",
  },
  {
    cover:
      "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Home%2Fkiacarouselcarnival.jpg?alt=media&token=2b3fc1bf-32f7-4c15-913b-175cdd30b022",
    link: "/carnival",
  },
  {
    cover:
      "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Home%2Fkiacarouselev9.jpg?alt=media&token=3dfb963b-e0f5-4e87-a5af-088d7bcb48c4",
    link: "/ev9",
  },
  {
    cover:
      "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Home%2Fkia%20Clavis%20carousel.jpg?alt=media&token=6213403e-bde3-4411-8a06-7abc442d100c",
    link: "/carens-clavis",
  },
];

const featureData = [
{
  title:
    "Dealership Network in Odisha | Seltos, Sonet, Carens, EV6 | Sales, Service & Spare",
  description: `Your Trusted Destination for Kia Vehicles in Odisha`,
  description1: `Central Kia is proud to be the largest Kia dealership network in Odisha, offering an extensive range of Kia cars to suit every lifestyle and budget. Whether you're looking for the stylish and powerful Kia Seltos, the compact and feature-packed Kia Sonet, the spacious and family-friendly Kia Carens, or the futuristic and eco-friendly Kia EV6, we have the perfect car for you.`,
  description2: `Wide Network of Showrooms & Service Centers
We have strategically located showrooms in Bhubaneswar, Cuttack, Angul, Jharsuguda, Sambalpur, Bargarh, and Berhampur, ensuring easy access to the latest Kia models, expert guidance, and a seamless purchasing experience. Our commitment to customer satisfaction extends beyond sales, with advanced service centers in Bhubaneswar, Sambalpur, and Berhampur providing professional maintenance, repairs, and genuine Kia spare parts.`,
  textAlign: "Right",
  image:
    "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/featureData%2Fso.jpeg?alt=media&token=fec2a470-1119-428a-bf58-738be3644312",
},
  {
    title: "Wide Presence Across Odisha",
    description: `We make it easy for you to experience the best of Kia, with
              showrooms located in:`,
    list: [
      "Angul",
      "Berhampur",
      "Bhubaneswar",
      "Cuttack", 
      "Jharsuguda",
      "Sambalpur",
    ],
    description1: `No matter where you are in Odisha, a Central Kia showroom is always within reach, providing you with seamless access to the latest Kia models, expert consultations, and a premium car-buying experience. Our widespread network ensures that you never have to travel far to explore the cutting-edge design, advanced technology, and superior performance of Kia vehicles.

Whether you're in a bustling city or a growing town, our showrooms are strategically located to bring you personalized assistance, competitive pricing, and hassle-free financing options. Our team of Kia-certified professionals is dedicated to guiding you through every step of your car-buying journey, from selecting the perfect model to securing the best deals.

At Central Kia, we don’t just sell cars—we build relationships. Our commitment to customer satisfaction, after-sales support, and high-quality maintenance services ensures that your Kia experience remains exceptional long after you drive off the lot.`,
    textAlign: "Left",
    image:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/featureData%2Fmap.png?alt=media&token=86a2c95a-9dc9-4ebf-8825-ba7fc31211b0",
  },
  {
    title:
      "State-of-the-Art Service Centers – Keeping Your Kia in Peak Condition",
    description: `At Central Kia, we are committed to ensuring that your Kia stays in top-notch condition, delivering optimal performance and reliability for years to come. Our state-of-the-art service centers in Bhubaneswar, Cuttack, Angul, Jharsuguda, Sambalpur, Jajpur, and Berhampur are equipped with the latest diagnostic tools, advanced technology, and a team of Kia-certified technicians who provide expert care for your vehicle.`,
    description1: `Comprehensive Kia Service & Maintenance  `,
    list1: [
      "Routine Maintenance & Inspections – Regular servicing, oil changes, and multi-point checks to keep your Kia running smoothly.  ",
      "Advanced Diagnostics & Repairs– Cutting-edge tools to identify and fix any mechanical or electrical issues efficiently.  ",
      "Genuine Kia Parts & Accessories – We use only authentic Kia spare parts to ensure durability, safety, and optimal vehicle performance. ",
      "Body & Paint Services – Expert solutions for scratches, dents, and accident repairs, restoring your Kia’s pristine look. ",
      "Tire & Wheel Alignment – Professional balancing, alignment, and replacement services for improved handling and safety. ",
    ],
    textAlign: "Right",
    image:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/featureData%2Fmgcentralservice.jpeg?alt=media&token=42711535-0fab-4c93-8897-bd73540df80d",
  },
  {
    title: "Why Choose Central Kia? – Your Trusted Kia Dealership in Odisha",
    description: `At Central Kia, we are committed to delivering an exceptional car-buying and ownership experience, ensuring that every customer enjoys world-class service, competitive deals, and top-tier vehicle maintenance. Here's why we are the preferred Kia dealership in Odisha:`,
    list: [
      "Customer-Centric Approach : We prioritize your needs and preferences, offering personalized assistance at every step of your Kia journey. Our expert team is here to guide you—from helping you choose the perfect model to securing financing and ensuring a smooth after-sales experience.",
      "Exclusive Offers & Financing Options : Drive home your dream Kia with our unbeatable deals, flexible financing options, and special discounts. Whether you’re looking for a budget-friendly EMI plan or a customized finance package, we make owning a Kia more affordable than ever.",
      "Comprehensive Services for a Hassle-Free Experience. At Central Kia, we offer end-to-end services, including:",
    ],
    sublist: [
      "Test Drives at Your Convenience – Experience your favorite Kia model before making a decision.",
      "Expert Vehicle Consultation – Get professional advice to choose the right Kia for your lifestyle and budget.",
      "Smooth Buying Process – Enjoy a seamless car-buying experience with transparent pricing and hassle-free documentation.",
      "After-Sales Support – Our dedicated team ensures you get the best service, from maintenance to spare parts and beyond.",
    ],
    textAlign: "Left",
    image:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/featureData%2Fmgcentralinter.jpeg?alt=media&token=c43ee762-726e-4950-8179-b6a9814efd75",
  },
  {
    title: "Experience the Central Kia Difference",
    description: `Experience the Central Kia Difference – Where Excellence Meets Trust Join the growing family of thousands of satisfied customers who rely on Central Kia for their automotive needs. We are more than just a dealership—we are your trusted partner in finding the perfect Kia, ensuring expert maintenance, and delivering an exceptional customer experience.`,
    description1: `What Sets Central Kia Apart?`,
    description2: `Unmatched Kia Selection – Explore our wide range of Kia models, from the stylish Sonet and Seltos to the spacious Carens and the innovative EV6. Our knowledgeable team helps you choose the Kia that best fits your lifestyle and budget.`,
    description3: `Seamless Buying Experience – Enjoy a hassle-free car-buying process with transparent pricing, quick documentation, and flexible financing options. We make your dream of owning a Kia effortless and enjoyable.`,
    description4: `World-Class Customer Service – At Central Kia, your satisfaction is our top priority. From the moment you step into our showroom to long after you drive away, we provide personalized assistance, expert guidance, and prompt support.`,
    description5: `State-of-the-Art Service & Genuine Parts – Our modern service centers in Bhubaneswar, Cuttack, Angul, Jharsuguda, Sambalpur, Jajpur, and Berhampur ensure that your Kia receives top-notch care using Kia-certified technicians and genuine parts. Whether it’s routine maintenance or major repairs, we keep your Kia running like new.`,
    textAlign: "Right",
    image:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/featureData%2Fmgcentralintr.jpeg?alt=media&token=fc24a189-bb82-410a-9bd5-7c14ab0ee4f3",
  },
];


// export const kiaData = {
//   leftBanner: {
//     img: "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/durgapujaimage.png?alt=media&token=094aedf8-0cf9-4035-b9ec-29f13f316960",
//     alt: "Kia Festive Offer",
//   },
//   rightOptions: [
//     {
//       id: 1,
//       title: "Book a Test Drive",
//       icon: <FaCar />,
//       bgColor: "#fff",
//       color: "#000",
//       type: "dialog",
//     },
//     {
//       id: 2,
//       title: "Get Quotations",
//       icon: <FaQuoteRight />,
//       bgColor: "#00111b",
//       color: "#fff",
//       type: "link",
//       link: "https://centralkia.co.in/get-quotation",
//     },
//     {
//       id: 3,
//       title: "Book Service Appointment",
//       icon: <FaCogs />,
//       bgColor: "#00111b",
//       color: "#fff",
//       type: "dialog",
//     },
//     {
//       id: 4,
//       title: "Download Brochure",
//       icon: <FaFileDownload />,
//       bgColor: "#fff",
//       color: "#000",
//       type: "link",
//       link: "https://centralkia.co.in/download-brochure",
//     },
//   ],
// };

















// exploreData.js

export const carCategories = ["SUV", "MPV", "EV"];

export const carData = [
  {
    id: 1,
    category: "SUV",
    name: "SELTOS",
    desc: " Bolder, bigger, and unmistakably badass, The all-new Seltos commands attention with muscular design and confident comfort that turn every drive into an experience.",
    image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/model%2FNEWSELTOScar.webp?alt=media&token=ebd262d9-e8ca-421a-854c-7973c6102bd2",
    link: "/newseltos",
  },
  {
    id: 2,
    category: "SUV",
    name: "SONET",
    desc: " Untamed by design, the new Kia Sonet unleashes raw power, bold style, and smart tech to set your wild driving instincts free.",
    image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/model%2FSonetcar.webp?alt=media&token=60de5fd9-5a2b-4ace-8a55-017b81301a1a",
    link: "/sonet",
  },
  {
    id: 3,
    category: "SUV",
    name: "SYROS",
    desc: "The new Kia Syros marks the next chapter in SUVs, blending futuristic design, smart technology, and first-of-its-kind features into a bold statement of progress and evolution.",
    image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/model%2FSyroscar.webp?alt=media&token=b561bbd3-822d-471a-b0d2-c114abc13fce",
    link: "/syros",
  },
  {
    id: 11,
    category: "SUV",
    name: "SORENTO",
    desc: "The global icon reimagined for India. The Kia Sorento brings bold design, Hybrid and AWD capability, 10 airbags and ADAS Level 2+ together in a premium 6 or 7-seater SUV.",
    image: "https://www.kia.com/content/dam/kia2/in/en/our-vehicles/sorento/Kia-Sorento-Car-600x300.png",
    link: "/sorento",
  },

  {
    id: 4,
    category: "MPV",
    name: "CARENS CLAVIS",
    desc: " Inspired by the “Golden Key,” the Carens Clavis unlocks epic family journeys with spacious comfort, smart innovation, and thoughtful design for every drive.",
    image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/model%2FClaviscar.webp?alt=media&token=ebb07d9a-59b4-41a5-bcfe-ff3e21666358",
    link: "/carens-clavis",
  },
  {
    id: 5,
    category: "MPV",
    name: "CARENS",
    desc: "The Kia Carens commands attention with bold attitude and space-age sophistication, delivering a style that inspires awe and stands apart from the ordinary. ",
    image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/model%2FCarenscar.webp?alt=media&token=4c542691-8892-4df5-84b5-8a66c8fba3b7",
    link: "/carens",
  },
  {
    id: 6,
    category: "MPV",
    name: "CARNIVAL",
    desc: "Your own luxury liner, the new Carnival Limousine announces your arrival in bold style while elevating every journey into an experience of pure comfort and opulence.",
    image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/model%2FCarnivalcar.webp?alt=media&token=bc0dfe0e-43d5-4fec-aeed-4afb3e80aecd",
    link: "/carnival",
  },
  {
    id: 7,
    category: "EV",
    name: "CARENS CLAVIS EV",
    desc: "Made for the family, the Carens Clavis EV invites you into a calm, connected space where comfort, technology, and togetherness come naturally.",
    image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/model%2FnewClavisEvcar.webp?alt=media&token=439b5efe-9921-460f-8db3-a83a1554a403",
    link: "/carens-clavis-ev",
  },
  {
    id: 8,
    category: "EV",
    name: "EV6",
    desc: "A futuristic, driver-centric cockpit where intuitive technology, sustainable design, and refined luxury come together for an immersive driving experience.",
    image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/model%2FEV6car.webp?alt=media&token=d30184a7-a107-4409-b0aa-2c902457c7ba",
    link: "/ev6",
  },
  {
    id: 9,
    category: "EV",
    name: "SYROS EV",
    desc: "The Kia Syros EV pairs a best-in-segment 526 km* certified range with bold SUV design, advanced safety, and intuitive connectivity - built to remove every doubt that comes with going electric.",
    image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros-ev%2F08-d.avif?alt=media&token=2940b50d-4d07-46cb-ae43-3de7008ae9fe",
    link: "/syros-ev",
  },
  {
    id: 9,
    category: "EV",
    name: "EV9",
    desc: "The Kia EV9 redefines electric mobility with expansive space, bringing everyone and everything together in effortless comfort. The World’s Most Inspiring Electric. Ever.",
    image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/model%2FEV9car.webp?alt=media&token=7558e0c3-84ed-4efd-8870-efedad6f9f4d",
    link: "/ev9",
  },
];
export { imagesHome, bannerData, featureData };


